module.exports = __webpack_public_path__ + "static/media/crow_dropping_roti_land.40493fd0.png";